import React from 'react'
import { toast } from 'react-toastify'
import { useSendContactMessageForm } from '../src/hooks/useSendContactMessageForm'
import { useTranslate } from '../src/hooks/useTranslate'
import { Button } from './Button'
import { GdprDisclaimer } from './GdprDisclaimer'
import { Input } from './Input'
import { Recaptcha } from './Recaptcha'

export interface QuestionFormProps {
	onRequestClose?: () => void
}

export const QuestionForm: React.FunctionComponent<QuestionFormProps> = ({
	onRequestClose,
}) => {
	const { sent, error, register, setValue, submit } = useSendContactMessageForm(
		{
			onSend: onRequestClose,
			type: 'question',
			staticMessageContent: undefined,
			providedSubject: undefined,
			providedEmail: undefined
		},
	)
	const translate = useTranslate();

	React.useEffect(() => {
		if (sent) {
			toast.success('Dotaz byl odeslán.')
		}
	}, [sent])

	React.useEffect(() => {
		if (error) {
			toast.error(error)
		}
	}, [error])

	return (
		<form className="questionForm" onSubmit={submit}>
			{error && <>{error}</>}
			<div className="questionForm-field">
				<Input
					autoFocus
					multiline
					label="Váš dotaz:"
					name="message"
					ref={register}
				/>
			</div>
			<div className="questionForm-field">
				<Input
					label="Vaše jméno:"
					autoComplete="name"
					required
					name="name"
					ref={register}
				/>
			</div>
			<div className="questionForm-field">
				<Input
					label="Vaš e-mail:"
					autoComplete="email"
					required
					name="email"
					ref={register}
				/>
			</div>
			<div className="questionForm-field">
				<Input
					label="Vaš telefon:"
					autoComplete="tel"
					required
					name="phone"
					ref={register}
				/>
			</div>
			<div className="questionForm-field">
				<Input
					label="Město:"
					autoComplete="address-level2"
					required
					name="place"
					ref={register}
				/>
			</div>
			<div className="questionForm-field">
				<GdprDisclaimer />
			</div>
			<div className="questionForm-recaptcha">
				<Recaptcha register={register} setValue={setValue} />
			</div>
			<div className="questionForm-submit">
				<Button type="submit" block>
					{translate('send-query')}
				</Button>
			</div>
		</form>
	)
}
